import React from "react";
import { Link } from "react-router-dom";
import l from "components/util/l";
import FolderItem from "components/presentation/start/Folders.sub.Item.view";

const Folders = ({
  folders,
  selectedFolder,
  setSelectedFolder,
}) => (
  <>
    <div id="start-nav-wrapper" className="d-flex justify-content-center">
      <div id="start-nav">
        <div class="card-body p-0">
          <aside class="navbar navbar-vertical-aside navbar-vertical navbar-bordered navbar-vertical-aside-initialized">
            <div class="navbar-vertical-container">
              <div class="navbar-vertical-footer-offset">


                <div id="start-settings-menu"
                  className="navbar-vertical-content mt-3 mb-2 mb-sm-5 overflow-hidden">
                  <ul class="navbar-nav navbar-nav-lg nav-tabs">

                    <li class="navbar-vertical-aside-has-menu">
                      <a class={`nav-link ${!selectedFolder && "active"}`} title="Principal"
                        style={{ cursor: "pointer" }} onClick={() => setSelectedFolder(null)}>
                        <i class="fas fa-home ml-1 mr-3"></i>
                        <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">{l("Todas las soluciones%SB080")}</span>
                      </a>

                      <ul class="nav nav-sub d-block">
                        {folders.map((folder) => (
                          <FolderItem folder={folder} key={folder.id} selectedFolder={selectedFolder} setSelectedFolder={setSelectedFolder} />
                        ))}
                        <li class="nav-item mt-1">
                          <Link className="nav-link create-folder-button" to="/create_folder">
                            <i class="fas fa-plus mr-3 ml-3"></i>
                            <span class="text-truncate">{l("Crear carpeta%SB006")}</span>
                          </Link>
                        </li>
                      </ul>

                    </li>

                  </ul>
                </div>

              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>

  </>
)


export default Folders;